export const getCountryCodes = (countryCode: string): string => {
    let formattedCountryCode = countryCode;

    if (formattedCountryCode === 'cs') {
        formattedCountryCode = 'cz';
    }

    return formattedCountryCode;
};
